import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import useTracking from '~/services/tracking'

import {
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography
} from '@material-ui/core'

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

export default ({ mobile } = {}) => {
  const classes = useStyles()
  const theme = useTheme()
  const tracking = useTracking()

  const {
    store,
    stores
  } = useSelector(state => state.storeReducers)
  const {
    employeeCpf,
    employeeName,
    login
  } = useSelector(state => state.loginReducers.loginData)
  const { campaign } = useSelector(state => state.campaignReducers)

  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenMenu = (event) => {
    tracking({ event: 'menu_topo_abre' })
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    tracking({ event: 'menu_topo_fecha' })
    setAnchorEl(null)
  }

  const handleChangeStore = () => {
    tracking({ event: 'menu_topo_muda_loja_click' })
    setAnchorEl(null)
  }

  const handleChangeCampaign = () => {
    tracking({ event: 'menu_topo_muda_campanha_click' })
    setAnchorEl(null)
  }

  const handleLogoff = () => {
    tracking({ event: 'menu_topo_logoff_click' })
    setAnchorEl(null)
  }

  return (
    <Grid container direction='row' wrap='nowrap' justify='center' className={clsx({ [classes.MENU_HIDE]: (!employeeCpf && !employeeName) })}>
      <Grid item>
        <Chip
          icon={<KeyboardArrowDownIcon />}
          label={(
            <Typography variant={mobile ? 'caption' : 'body1'} align='center'>
              <FormattedMessage
                id='Olá, {name}! {cpf}'
                values={{
                  name: (employeeName || login),
                  cpf: (
                    <Typography
                      variant={mobile ? 'caption' : 'body1'}
                      component='span'
                      color={theme.palette?.inverse ? 'primary' : 'secondary'}
                    >
                      {(employeeCpf ? employeeCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4') : '')}
                    </Typography>
                  )
                }}
              />
            </Typography>
          )}
          className={clsx(classes.CHIP, { [classes.CHIP_MOBILE]: mobile })}
          clickable
          onClick={handleOpenMenu}
          size='small'
        />
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseMenu}
          className={(mobile ? classes.MENU_MOBILE : classes.MENU)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          <List component='nav'>
            {(stores && stores.length > 1) && (
              <>
                <ListItem button component={Link} to='/hub' onClick={handleChangeStore} disabled={!(store?.storeName)}>
                  <ListItemText primary='mudar de loja' align='center' />
                </ListItem>
                <Divider />
              </>
            )}
            <ListItem button component={Link} to='/hub' onClick={handleChangeCampaign} disabled={!(campaign?.campaignName)}>
              <ListItemText primary='mudar de campanha' align='center' />
            </ListItem>
            <Divider />
            <ListItem button component={Link} to='/logoff' onClick={handleLogoff}>
              <ListItemText primary='sair da plataforma' align='center' />
            </ListItem>
          </List>
        </Popover>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme) => ({
  CHIP: {
    ...(
      theme.palette?.inverse ? (
        {
          background: theme.palette.tertiary.main,
          color: theme.palette.secondary.main
        }
      ) : (
        {
          background: theme.palette.background.paper,
          color: theme.palette.primary.main
        }
      )
    ),
    borderRadius: 20,
    height: 40,
    padding: 8,
    '& .MuiChip-icon': {
      color: (theme.palette?.inverse ? theme.palette.secondary.main : theme.palette.primary.main)
    },
    '&:hover, &:active, &:focus': {
      background: `${(theme.palette?.inverse ? theme.palette.tertiary.main : theme.palette.background.paper)}cc`
    }
  },
  CHIP_MOBILE: {
    height: 24,
    padding: 4
  },
  MENU_HIDE: {
    visibility: 'hidden'
  },
  MENU: {
    '& .MuiPopover-paper': {
      marginTop: 20,
      padding: '0 20px',
      background: theme.palette['neutral-light'].main,
      overflow: 'visible',
      '& a': {
        color: theme.palette['neutral-dark'].main
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: -10,
        left: 15,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: `transparent transparent ${theme.palette['neutral-light'].main} transparent`
      }
    }
  },
  MENU_MOBILE: {
    backgroundColor: 'rgb(0 0 0 / 65%)',
    '& .MuiPopover-paper': {
      marginTop: 20,
      padding: '0 20px',
      width: '100%',
      background: theme.palette['neutral-light'].main,
      overflow: 'visible',
      '& a': {
        color: theme.palette['neutral-dark'].main
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: -9,
        left: '50%',
        marginLeft: -10,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: `transparent transparent ${theme.palette['neutral-light'].main} transparent`
      }
    }
  }
}))
